import * as solid from './v6/solid'
import * as regular from './v6/regular'
import * as light from './v6/light'
import * as thin from './v6/thin'
import * as duotone from './v6/duotone'
import * as duotoneRegular from './v6/duotoneRegular'
import * as duotoneLight from './v6/duotoneLight'
import * as duotoneThin from './v6/duotoneThin'
import * as brands from './v6/brands'
import * as sharpSolid from './v6/sharpSolid'
import * as sharpRegular from './v6/sharpRegular'
import * as sharpLight from './v6/sharpLight'
import * as sharpThin from './v6/sharpThin'
import * as sharpDuotoneSolid from './v6/sharpDuotoneSolid'
import * as sharpDuotoneRegular from './v6/sharpDuotoneRegular'
import * as sharpDuotoneLight from './v6/sharpDuotoneLight'
import * as sharpDuotoneThin from './v6/sharpDuotoneThin'

import * as custom from './custom'

export default {
  solid,
  regular,
  light,
  thin,
  duotone,
  duotoneLight,
  duotoneThin,
  duotoneRegular,
  brands,
  sharpSolid,
  sharpRegular,
  sharpLight,
  sharpThin,
  sharpDuotoneSolid,
  sharpDuotoneRegular,
  sharpDuotoneLight,
  sharpDuotoneThin,
  custom
}
